import {
  FreeLink as FreeLinkLib,
  pickFreeLinkSettings
} from '@elfsight/widget-free-link';
import { useSettings } from '@wu/widget-core';
import { meta } from '../../../meta';

export function FreeLink() {
  const settings = useSettings();
  const freeLinkSettings = pickFreeLinkSettings(settings);

  return (
    <FreeLinkLib
      {...freeLinkSettings}
      appAlias={meta.alias}
      appName={meta.name}
      style={{
        link: {
          width: 'max-content',
          marginTop: '24px',
          transform: 'translateX(0)',
          left: 0
        }
      }}
    />
  );
}
